import { useBooleanFlagValue } from '@openfeature/react-sdk';

/**
 * Whether admins can move an agent into another Tools Hub category.
 *
 * The flag is named for External Tools because that was the first surface to expose the picker;
 * it now gates the picker on every agent's config page. Centralizing the check keeps the flag
 * key in one place.
 */
export function useIsCategoryPickerEnabled(): boolean {
  return useBooleanFlagValue('external_tools_category_picker', false);
}
